import { createTypes } from '../../utils/helpers';

const MANAGE_DAYS_OFF: any = createTypes('MANAGE_DAYS_OFF');
const SET_REANGE_DAYS = 'SET_REANGE_DAYS';
const SET_SINGLE_DAY = 'SET_SINGLE_DAY';

const SPECIAL_EVENT_SET_EDITED = 'SPECIAL_EVENT_SET_EDITED';
const SET_SPECIAL_EVENT_OPERATION_HOUR = 'SET_SPECIAL_EVENT_OPERATION_HOUR';
const SET_DEFAULT_RANGE = 'SET_DEFAULT_RANGE';
const SET_DEFAULT_SINGLE = 'SET_DEFAULT_SINGLE';

const SET_DEFAULT_SPECIAL_EVENT_REASON_SELECTED =
  'SET_DEFAULT_SPECIAL_EVENT_REASON_SELECTED';
const SET_SPECIAL_EVENT_REASON_SELECTED = 'SET_SPECIAL_EVENT_REASON_SELECTED';

export {
  MANAGE_DAYS_OFF,
  SPECIAL_EVENT_SET_EDITED,
  SET_SPECIAL_EVENT_OPERATION_HOUR,
  SET_REANGE_DAYS,
  SET_SINGLE_DAY,
  SET_DEFAULT_RANGE,
  SET_DEFAULT_SINGLE,
  SET_DEFAULT_SPECIAL_EVENT_REASON_SELECTED,
  SET_SPECIAL_EVENT_REASON_SELECTED,
};
